// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"60":"noticeDetail","65":"newsDetail","842":"map"}[chunkId] + "." + {"60":"c1f74983","65":"d90e516c","842":"c52438e9"}[chunkId] + ".css";
};